export const getPlatformContext = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem("myv_platform_context");
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const getPlatformRole = () => {
  const context = getPlatformContext();
  return context?.user?.role || null;
};

export const isAdminRole = (role) =>
  String(role || "").toUpperCase() === "ADMIN";
